// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1909205f","455":"4540fe0a","977":"1fb76a0b"}[chunkId] + ".chunk.js";
};